<template>
    <SubLayout
        :pageTitle="title"
        :pageBreadcrumbs="breadcrumbs"
        :hasBack="false"
    >
      <template #layoutContent>
        <Card :title="$t('access.card.title')" containerClass="mb-5 mt-5">
          <template #cardToolbar>
            <div class="d-flex justify-content-end align-items-center">
              <div class="d-flex justify-content-center">
                <ButtonDropdownFilter
                    :search="false"
                    :options="getStatusWithAll"
                    value-field="value"
                    :name-field="locale"
                    v-model="query.status"
                    btnClass="btn-md"
                />
                <Button type="new" v-if="$can(abilities.CAN_CARD_CONFIG_CREATE)" btn-class="me-3 btn-sm" btn-text="access.card.create"  @click="openCreateModal" ></Button>
              </div>
            </div>
          </template>
          <template #cardBody>
            <table class="table align-middle table-row-bordered fs-6 gy-3 gx-4"
                     id="kt_datatable_cards">
                <thead class="mb-5">
                <tr class="fw-bold fs-6" style="background-color: #F2F3F4;">
                  <th class="min-w-100px text-center">{{ $t('access.card.number') }}</th>
                  <th class="min-w-100px text-center">{{ $t('access.card.assigned_to') }}</th>
                  <th class="min-w-100px text-center">{{ $t('access.card.status') }}</th>
                  <th class="min-w-100px text-center">{{ $t('access.card.last_assigned_at') }}</th>
                  <th>{{$t("actions")}}</th>
                </tr>
                </thead>
            </table>
          </template>
        </Card>

        <UpdateCards :form="formEdit" @load="reloadDatatable" id="updateCardsModal" :isEdit="true" />
        <CreateCards @load="reloadDatatable" id="createCardsModal" />
        <ChangeCardStatus :form="formEdit" @load="reloadDatatable" id="changeStatusCardsModal" />
        <AssignCards :form="formEdit" @load="reloadDatatable" id="assignCardsModal" />
        <ConfigCardModal id="configCardsModal" :card-id="formEdit.id"/>
      </template>
    </SubLayout>
</template>

<script setup>
    import {computed, nextTick, onMounted, ref, watch,onUnmounted} from "vue";
    import SubLayout from "@/views/Layouts/partials/SubLayout.vue";
    import {useStore} from "vuex";
    import i18n from "@/plugins/i18n";
    import Ls from "@/services/ls";
    import {BASE_URL} from "@/services/api";
    import {useLocales} from "@/composables/locales";
    import {useHasAbility} from "@/composables/hasAbility";
    import Card from "@/Modules/CRM/components/Card";
    import ButtonDropdownFilter from "@/components/ButtonDropdownFilter.vue";
    import { useI18n } from 'vue-i18n';
    import { useRouter } from 'vue-router';
    import {Theme} from "@/composables/theming";
    import Button from "@/components/Button.vue";
    import UpdateCards from "@/Modules/Access/components/Modals/Cards/CreateOrUpdateCards.vue";
    import CreateCards from "@/Modules/Access/components/Modals/Cards/CreateOrUpdateCards.vue";
    import {useSwal} from "@/composables/useSwal";
    import ChangeCardStatus from "@/Modules/Access/components/Modals/Cards/ChangeCardStatus.vue";
    import AssignCards from "@/Modules/Access/components/Modals/Cards/AssignCards.vue";
    import ConfigCardModal from "./components/ConfigCardModal.vue";
    import abilities from "@/composables/abilities";

    const store = useStore()
    const { can } = useHasAbility()
    const {showSwal} = useSwal()
    const {locale, datatableLocaleUrl} = useLocales()
    const { t } = useI18n({ useScope: 'global' })
    const router = useRouter();
    const title = ref("menu.access.cards")
    const breadcrumbs = ref([
        {
            name: 'access.card.title',
            route: 'access-cards'
        }
    ])

    const table = ref()
    const query = ref({
        status: '',
    })
    const formEdit = ref({
      id: '',
      card_number: '',
      status: '',
    })


    const getCardStatus = computed(() => store.getters['cards/getCardStatus'])


    const getStatusWithAll = computed(() => {
        return [{fr: t('access.historics.all_status'), en: t('access.historics.all_status'), value: ''}, ...getCardStatus.value]
    })

    watch(() => locale.value, (value) => {
        nextTick(() => fetchDatas() )
    }, { deep: true })

    watch(() => query.value.status, (newValue) => {
        table.value.ajax.url(`${BASE_URL}/get/card/dataTable?status=${query.value.status}`).load()
    })

    function openCreateModal(){
      $('#createCardsModal').modal('toggle')
    }


    function reloadDatatable(){
      table.value.ajax.reload()
    }

    function fetchDatas() {
        const AUTH_TOKEN = Ls.get('auth.token')
        const pageLimit = Ls.get('pageLength')

        table.value = $("#kt_datatable_cards").DataTable({
            destroy: true,
            responsive: !0,
            searchDelay: 500,
            processing: !0,
            serverSide: !0,
            pageLength: pageLimit ||  5,
            lengthMenu: [5, 10, 25, 50, 75, 100 ],
            order: [[ 0, 'desc']],
            ajax: {
            url: BASE_URL + `/get/card/dataTable?status=${query.value.status}`,
            type: "GET",
            beforeSend: function (request) {
                request.setRequestHeader("Authorization", "Bearer " + AUTH_TOKEN);
                request.setRequestHeader("Company", Ls.get('current.company'));
            }
            },
            columns: [
            { data: "card_number" }, { data: "assigned_to" },{ data: "status" }, { data: "last_assigned_at" },{ data: "Actions", responsivePriority: -1 },
            ],
            columnDefs: [

            {
                targets: -5,
                orderable: !1,
                className: "dt-center text-center clickable" ,
                render: function (t, a, e, l) {
                return '<span data-id="'+ e.id +'">' + t + "</span>";
                },
            },
              {
                targets: -4,
                orderable: !1,
                className: "dt-center text-center clickable" ,
                render: function (t, a, e, l) {
                return '<span data-id="'+ e.id +'">' + t + "</span>";
                },
            },
              {
                targets: -3,
                orderable: false,
                className: "dt-center text-center",
                render: function (data, type, row, meta) {
                  const statusInfo = getCardStatusName(data);
                  const currentLocale = i18n.global.locale.value;
                  const statusText = statusInfo[currentLocale] || data;
                  const colorClass = statusInfo.color || 'secondary';

                  return '<span class="badge badge-' + colorClass + ' fs-7 fw-bold">' + statusText + '</span>';
                }
              },
            {
                targets: -2,
                order: "desc",
                className: "dt-center text-center clickable" ,
                render: function (t, a, e, l) {
                return '<span data-id="'+ e.id +'">' + t + "</span>";
                },
            },

              {
                width: "16%",
                targets: -1,
                "className": "dt-center",
                title: "Actions",
                orderable: !1,
                render: (t, a, e, l) => {
                  let render = '';

                  const isAssigned = e.status === 'assigned';
                  const isLost = e.status === 'lost';
                  const isBlocked = e.status === 'blocked';

                  if (!isAssigned && !isLost && !isBlocked && can(abilities.CAN_CARD_CONFIG_ASSIGN)) {
                    render += `<a href="javascript:;" data-row="${l.row}" data-id="${e.id}" data-card-number="${e.card_number}" data-card-status="${e.status}" class="btn btn-sm btn-clean btn-icon assign_btn" title="${i18n.global.t('access.card.assign')}">
                <i data-row="${l.row}" data-id="${e.id}" data-card-number="${e.card_number}" data-card-status="${e.status}" class="fas fa-user-plus fs-5" style="color: ${Theme.gray}"></i>
            </a>`;
                  }

                  if (isAssigned && can(abilities.CAN_CARD_CONFIG_UNASSIGN)) {
                    render += `<a href="javascript:;" data-row="${l.row}" data-id="${e.id}" data-card-number="${e.card_number}" data-card-status="${e.status}" class="btn btn-sm btn-clean btn-icon unassign_btn" title="${i18n.global.t('access.card.unassign')}">
                      <i data-row="${l.row}" data-id="${e.id}" data-card-number="${e.card_number}" data-card-status="${e.status}" class="fas fa-user-minus fs-5" style="color: ${Theme.gray}"></i>
                  </a>`;
                  }
                  if (!isAssigned && can(abilities.CAN_CARD_CONFIG_STATUS_CHANGE)) {
                    render += `<a href="javascript:;" data-row="${l.row}" data-id="${e.id}" data-card-number="${e.card_number}" data-card-status="${e.status}" class="btn btn-sm btn-clean btn-icon status_btn" title="${i18n.global.t('access.card.change_status')}">
                    <i data-row="${l.row}" data-id="${e.id}" data-card-number="${e.card_number}" data-card-status="${e.status}" class="fas fa-exchange-alt fs-5" style="color: ${Theme.gray}"></i>
                </a>`
                  }
                  ;

                  if (can(abilities.CAN_CARD_CONFIG_UPDATE))
                    render += `<a href="javascript:;" data-row="${l.row}" data-id="${e.id}" data-card-number="${e.card_number}" class="btn btn-sm btn-clean btn-icon edit_btn" title="${i18n.global.t('button.edit')}">
                      <i data-row="${l.row}" data-id="${e.id}" data-card-number="${e.card_number}" class="fas fa-edit fs-5" style="color: ${Theme.gray}"></i>
                  </a>`;

                  if (!isAssigned && can(abilities.CAN_CARD_CONFIG_DELETE)) {
                    render += `<a href="javascript:;" data-row="${l.row}" data-id="${e.id}" data-card-number="${e.card_number}" class="btn btn-sm btn-clean btn-icon delete_btn" title="${i18n.global.t('button.delete')}">
                      <i data-row="${l.row}" data-id="${e.id}" data-card-number="${e.card_number}" class="fas fa-trash fs-5" style="color: ${Theme.gray}"></i>
                  </a>`;
                  }

                  if (can(abilities.CAN_CARD_CONFIGURE)){
                    render += `<a href="javascript:;"
                   data-row="${l.row}"
                   data-id="${e.id}"
                   class="btn btn-sm btn-clean btn-icon config_btn"
                   title="${i18n.global.t('access.card.configure')}">
                    <i data-id="${e.id}" class="fas fa-cog fs-5" style="color: ${Theme.gray}"></i>
                </a>`
                }
                if (can(abilities.CAN_CARD_CONFIG_HISTORY_VIEW)) {
                  render += `<a href="javascript:;"
                      data-row="${l.row}" data-id="${e.id}"
                      class="btn btn-sm btn-clean btn-icon history_btn"
                      title="${i18n.global.t('access.card.history')}">
                      <i data-row="${l.row}" data-id="${e.id}" class="fas fa-history fs-5" style="color: ${Theme.gray}"></i>
                  </a>`;
                }
                  return `<div class="d-flex justify-content-center gap-1">${render}</div>`;
                },
              }
            ],
            language: {
            url: datatableLocaleUrl.value,
            }
        });

      $(document).on("click", "#kt_datatable_cards .edit_btn", (e) => {
        formEdit.value.id = e.target.getAttribute('data-id')
        formEdit.value.card_number = e.target.getAttribute('data-card-number')
        $('#updateCardsModal').modal('toggle')
      });


      $(document).on("click", "#kt_datatable_cards .status_btn", (e) => {
        formEdit.value.id = e.target.getAttribute('data-id')
        formEdit.value.status = e.target.getAttribute('data-card-status')
        $('#changeStatusCardsModal').modal('toggle')
      });

      $(document).on("click", "#kt_datatable_cards .assign_btn", (e) => {
        formEdit.value.id = e.target.getAttribute('data-id')
        $('#assignCardsModal').modal('toggle')
      });

      $(document).on("click", "#kt_datatable_cards .config_btn", (e) => {
        formEdit.value.id = e.target.getAttribute('data-id')
        $('#configCardsModal').modal('toggle')
      });

      $(document).off("click", "#kt_datatable_cards .history_btn").on("click", "#kt_datatable_cards .history_btn", (e) => {
        let cardId =  e.target.getAttribute('data-id')

        router.push({
          name: 'access-card-history',
          params: { id: cardId }
        });
      });

    }


    function getCardStatusName(status) {
      const statusObj = getCardStatus.value.find(el => el.value === status);
      if (!statusObj) return {
        name: status,
        fr: status,
        en: status,
        color: 'secondary'
      };

      const currentLocale = i18n.global.locale.value;
      return {
        name: statusObj[currentLocale] || statusObj.fr || statusObj.en || status,
        fr: statusObj.fr || status,
        en: statusObj.en || status,
        color: statusObj.color || 'secondary',
        className: statusObj.color ? `badge-${statusObj.color}` : 'badge-secondary'
      };
    }

    $(document).on("click", "#kt_datatable_cards .unassign_btn", (e) => {
      returnCards(e.target.getAttribute('data-id'))
    });



    $(document).on("click", "#kt_datatable_cards .delete_btn", (e) => {
      deleteCards(e.target.getAttribute('data-id'))
    });


    async function deleteCards(id){
      showSwal(
          t('access.card.swal_delete_title'),
          t('access.card.swal_delete_text')
      ).then( async (result) => {
        if (result.value) {
          try {
            await store.dispatch('cards/deleteCards', id)
            reloadDatatable()
            window.toastr.success(t('notification.card_deleted'))
          } catch (e) {
          }
        }
      });
    }

    async function returnCards(id){
      showSwal(
          t('access.card.swal_return_title'),
          t('access.card.swal_return_text')
      ).then( async (result) => {
        if (result.value) {
          try {
            await store.dispatch('cards/returnCards', id)
            loadAssignable()
            reloadDatatable()
            window.toastr.success(t('notification.card_returned'))
          } catch (e) {
          }
        }
      });
    }
    function loadData() {
        Promise.all([
            store.dispatch('cards/loadCardStatus'),
           store.dispatch('user/loadUsers'),
            store.dispatch('contacts/loadContacts'),
            fetchDatas()
        ])
    }

    function loadAssignable() {
      store.dispatch('cards/loadAssignCard')
    }

    onMounted( () => {
        loadData()
    })


</script>